import axios from 'axios';
import authHeader from './auth-header';
const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    // ✅ NUR USER-BEZOGENE METHODEN
    async addUsers(user) {
        user.type = "users"
        const response = await axios.post(API_URL + "/user", user, { headers: authHeader() });
        return (response.data);
    },

    async getUsers() {
        const response = await axios.get(API_URL + "/user", { headers: authHeader()});
        return (response.data);
    },

    async deleteUser(userId) {
        await axios.delete(API_URL + "/user/" + userId, { headers: authHeader() });
    },
    
    async getUserById(data) {
        const response = await axios.get(API_URL + "/user/" + data , { headers: authHeader() });
        return (response.data);
    },
    
    async updateUser(data, user) {
        console.log('Updating userservice with data:', data, 'and user:', user);
        const response = await axios.patch(API_URL + "/user/" + data, user, { headers: authHeader() });
        return (response.data);
    },

    // ✅ CUSTOMER-BEZOGENE METHODEN
    async getCustomers() {
        const response = await axios.get(API_URL + "/customers", { headers: authHeader()});
        return (response.data);
    },

    async updateCustomer(user) {
        const response = await axios.patch(API_URL + "/customer/" + user.id, user, { headers: authHeader() });
        return (response.data);
    },

    async deleteCustomer(userId) {
        await axios.delete(API_URL + "/customer/" + userId, { headers: authHeader() });
    },

    // ✅ PASSWORD & ROLE METHODEN
    async updatePassword(user) {
        const response = await axios.post(API_URL + "/change" ,user, { headers: authHeader() });
        return (response.data);
    },

    async fetchRole() {
        const response = await axios.get(API_URL + "/role", { headers: authHeader()});
        return (response.data);
    },

    async enableUser(userId) {
        try {
            const response = await axios.patch(
                API_URL + "/enableUser/" + userId,
                {}, // empty body
                { headers: authHeader() }
            );
            return response.data;
        } catch (error) {
            console.error("Error enabling user:", error);
            throw error;
        }
    },

    // ✅ DASHBOARD & STATISTICS
    async getUserCount() {
        const response = await axios.get(API_URL + "/dashboard", { headers: authHeader()});
        return (response.data);
    },

    async deleteCall(cid) {
        await axios.delete(API_URL + "/calls/" + cid, { headers: authHeader() });
    },

    async getCallsById() {
        const response = await axios.get(API_URL + "/callsview", { headers: authHeader()});
        return (response.data);
    },

    async updateCallStatus(calls) {
        const response = await axios.patch(API_URL + "/updateCallStatus/"+calls.id,calls, { headers: authHeader()});
        return (response.data);
    },

    async updateBulkStatus(calls) {
        const dataToSend = { calls };
        const response = await axios.patch(API_URL + "/updateBulkStatus", dataToSend, { 
            headers: authHeader() 
        });
        return response.data;
    },

    async getNotesForCall(cid) {
        const response = await axios.get(API_URL + "/notes/"+cid, { headers: authHeader()});
        return (response.data);
    },

    async addNoteToCall(id,note) {
        const response = await axios.post(API_URL + "/notes/"+id,note, { headers: authHeader()});
        return (response.data);
    },

    async getNewCalls() {
        const response = await axios.get(API_URL + "/newcalls", { headers: authHeader()});
        return (response.data);
    },

    async updateNotificationStatus(calls) {
        const dataToSend = { calls };
        const response = await axios.patch(API_URL + "/updateNotificationStatus", dataToSend, { 
            headers: authHeader() 
        });
        return response.data;
    },

    async updateCallStatusCompleted(calls) {
        const response = await axios.patch(API_URL + "/updateCallStatusCompleted/"+calls.id, { headers: authHeader()});
        return (response.data);
    },

    async sendSms(calls) {
        const response = await axios.post(API_URL + "/sendSms",calls, { headers: authHeader()});
        return (response.data);
    },

    async getcompletedCalls() {
        const response = await axios.get(API_URL + "/completed", { headers: authHeader()});
        return (response.data);
    },

    async updateCallCategory(calls) {
        const response = await axios.patch(API_URL + "/updateCallCategory/"+calls.id,calls, { headers: authHeader()});
        return (response.data);
    },

    async updateCallPriority(calls) {
        const response = await axios.patch(API_URL + "/updateCallPriority/"+calls.id,calls, { headers: authHeader()});
        return (response.data);
    },

    async getCategoryList() {
        const response = await axios.get(API_URL + "/getCategory", { headers: authHeader()});
        return (response.data);
    },

    async deleteOldCallLogs() {
        const response = await axios.delete(API_URL + "/deleteOldCallLogs", {
            headers: authHeader()
        });
        return response.data;
    },

    async fetchCallsCount(month) {
        const response = await axios.get(API_URL + "/fetchCallsCount", {
            headers: authHeader(),
            params: { month }
        });
        return response.data;
    }

    // ✅ ALLE VBOT-METHODEN ENTFERNT:
    // - addVbots, getVbots, getVbotById, updateVbot, deleteVbot
    // - getPhonebots, updatePhonebot
    // - getVbotByIdByGuest, updateVbotByGuest
};